import { ADMIN_NAV } from "./admin-nav.const";

// Maps a route pathname to a human page title for `document.title`
// (WCAG 2.4.2 Page Titled). Longest matching prefix wins, so more specific
// routes (e.g. `/knowledge-base-unavailable`) take precedence over shorter
// ones (`/knowledge-base`) regardless of list order.
//
// Company-scoped admin routes derive from ADMIN_NAV (Phase C single nav
// constant); only routes that render a page are listed — the retired
// per-Assistant settings routes redirect and never hold a title.
const PAGE_TITLES: ReadonlyArray<readonly [prefix: string, title: string]> = [
    ...ADMIN_NAV.map(entry => [entry.path, entry.title] as const),
    ["/dashboard", "Dashboard"],
    ["/new-chat", "Chat"],
    ["/chat/", "Chat"],
    ["/knowledge-base-unavailable", "Assistant Unavailable"],
    ["/knowledge-base", "Files"],
    ["/compare-recognition-result", "Compare Recognition"],
    ["/recognition-result", "Recognition Result"],
    ["/registration-success", "Email Confirmed"],
    ["/registration", "Sign Up"],
    ["/login", "Sign In"],
    ["/forgot-password", "Forgot Password"],
    ["/email-confirm", "Confirm Your Email"],
    ["/trial-upgrade", "Upgrade"],
    ["/google-picker", "Select Files"],
    ["/error", "Error"]
];

/**
 * Returns the page label for a pathname, or "" when none matches (callers fall
 * back to the bare app name). Uses longest-prefix matching to avoid collisions
 * between nested routes that share a leading segment.
 */
export const getPageTitle = (pathname: string): string => {
    let title = "";
    let matchedLen = -1;
    for (const [prefix, label] of PAGE_TITLES) {
        if ((pathname === prefix || pathname.startsWith(prefix)) && prefix.length > matchedLen) {
            title = label;
            matchedLen = prefix.length;
        }
    }
    return title;
};
